import React, {useEffect, useRef, useState} from "react";
import "./PrescriptionDetails.scss";
import PatienPrescription from "./PatienPrescription/PatienPrescription";
// import MedicinePrescription from "./MedicinePrescription/MedicinePresciption";
import {useDispatch} from "react-redux";
import {
  setDetailRecord,
  setEnableSLHoanTra,
  setLoading,
  setSalePrescription,
  setShowHoanLai,
} from "redux/reducer/medicineStore";
import {useAppSelector} from "redux/hooks";
import {medicineStoreService} from "api";
import {Divider, Spin, Typography, message} from "antd";
import MedicinePrescription from "./MedicinePrescription/MedicinePresciption";
import Notification from "components/common/notification/notification";
import {tabKeys} from "types/enums";
const PrescriptionDetails = () => {
  const dispatch = useDispatch();
  const loading = useAppSelector(state => state.medicineStore.loading);
  const selectedRecord = useAppSelector(
    state => state.medicineStore.selectedRecord
  );
  const activeTab = useAppSelector(state => state.common.activeTab);
  const listMedicineRef = useRef<any>(null);
  useEffect(() => {
    if (selectedRecord) {
      getDetailPrescription(selectedRecord.id);
    } else {
      dispatch(setDetailRecord(null));
    }
  }, [selectedRecord]);
  useEffect(() => {
    if (activeTab == tabKeys.MEDICINE_STORE.PRESCRIPTION_DETAIL) {
      // dispatch(setShowHoanLai(false));
      dispatch(setEnableSLHoanTra(false));
    }
  }, [activeTab]);
  const getDetailPrescription = async id => {
    try {
      dispatch(setLoading(true));
      const res = await medicineStoreService.getDetailPrescription(id);
      dispatch(setLoading(false));
      dispatch(setDetailRecord(res));
    } catch (error) {
      dispatch(setLoading(false));
      Notification("error", "Đã có lỗi khi lấy thông tin phiếu");
    }
  };

  return (
    <Spin spinning={loading}>
      <div className="detail-patient-analysis">
        <div className="container">
          <Typography.Text style={{fontWeight: "bold"}}>
            Thông tin phiếu
          </Typography.Text>
          <Divider style={{margin: 12}}></Divider>
          <div className="container-main">
            <PatienPrescription
              listMedicineRef={listMedicineRef}
            ></PatienPrescription>
          </div>
        </div>
        {/* <div className="container">
          <StepPrescription></StepPrescription>
        </div> */}

        <div>
          <MedicinePrescription ref={listMedicineRef}></MedicinePrescription>
        </div>
      </div>
    </Spin>
  );
};

export default PrescriptionDetails;
